import React from 'react'
import Label from 'LuxKit/Label'

const mapLabelToMessage: Record<string, string> = {
  redeemed: 'Reward redeemed',
  pending_selection: 'Reward available',
  pending_cooldown: 'First trip booked',
}

const labelToVariant: Record<string, Partial<React.ComponentProps<typeof Label>['variant']>> = {
  redeemed: 'ghost',
  pending_selection: 'highlight',
  pending_cooldown: 'fast',
}

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  referralLabel: string
}

function ReferralLabel(props: Props) {
  const { referralLabel, ...rest } = props

  return <Label {...rest} kind="tertiary" variant={labelToVariant[referralLabel]}>
    {mapLabelToMessage[referralLabel]}
  </Label>
}

export default ReferralLabel
